import { useState, useEffect, useCallback, useRef } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

export function filterFilledParams(params) {
  return Object.fromEntries(Object.entries(params).filter(([_, value]) => value))
}

export const createSearchParams = (params = {}) => {
  return new URLSearchParams(filterFilledParams(params)).toString()
}

function useSearchParams() {
  const history = useHistory()
  const location = useLocation()

  // Simpan search params dalam bentuk string agar lebih stabil
  const [searchString, setSearchString] = useState(location.search)
  const prevSearchRef = useRef(location.search)

  const updateSearchParams = useCallback(
    (newParams) => {
      const currentParams = new URLSearchParams(location.search)

      Object.keys(newParams).forEach((key) => {
        if (newParams[key]) {
          currentParams.set(key, newParams[key])
        } else {
          currentParams.delete(key)
        }
      })

      const newSearch = `?${currentParams.toString()}`

      // Cek apakah ada perubahan sebelum update
      if (newSearch !== location.search) {
        history.push({
          search: newSearch,
        })
      }
    },
    [history, location.search]
  )

  useEffect(() => {
    if (prevSearchRef.current !== location.search) {
      prevSearchRef.current = location.search
      setSearchString(location.search) // Update hanya jika ada perubahan
    }
  }, [location.search])

  return [new URLSearchParams(searchString), updateSearchParams]
}

export default useSearchParams
